import React, { Component } from 'react'
import { connect } from 'react-redux'
import { delay } from '../Animations/helper'
import { GetPlayerWithIndexByNum } from '../../reducers/index'
import BaseInfo from './BaseInfo'

class SubstitutionInfo extends BaseInfo {
    
    renderContent() {               
        return (<div>
                    {this.props.in} - {this.props.out}
                </div>)
    }
}

function mapStateToProps(state, ownProps) {
    let event = ownProps.event;

    let teamState = event.team == 1 ? state.HomeTeam : state.AwayTeam;
    let res = GetPlayerWithIndexByNum(teamState.Players, event.out);
    let outPlayer = res.player;
    res = GetPlayerWithIndexByNum(teamState.Players, event.in);
    let inPlayer = res.player;
    
    return {
        in: inPlayer.Name.LastName,
        out: outPlayer.Name.LastName,
        id: ownProps.id,
        onHide: ownProps.onHide
    };
}

export default connect(mapStateToProps)(SubstitutionInfo)


/** WEBPACK FOOTER **
 ** ./src/components/Info/SubstitutionInfo.js
 **/